module.exports = __webpack_public_path__ + "static/media/obraz-nad-hlavnim-oltarem.0b8c6929.jpg";